import { useState } from 'react'
import { Typography } from '@mui/material'
import ContextCard from '@/components/ContextCard/ContextCard'
import { useAutomationSetup } from '@/features/automations/useAutomationSetup'
import { useAutomations } from '@/features/automations/useAutomations'
import { useScheduleDetailsOptional } from '@/features/scheduleDetails/useScheduleDetails'
import AutomationSetupContent from './AutomationSetupContent'
import { DEFAULT_APPROVAL_DAYS } from './automationSetupApprovalCopy'

export default function AutomationSetupCardBlock({ block }) {
  const [days, setDays] = useState(DEFAULT_APPROVAL_DAYS)
  const setup = useAutomationSetup(block.automation_id)
  const [activated, setActivated] = useState(false)
  const schedule = useScheduleDetailsOptional()
  const scheduleRow =
    (useAutomations('schedules', { staleTime: 0 }).data ?? []).find(
      (row) => row.automationId === block.automation_id,
    ) ?? null
  const onOpen =
    schedule && scheduleRow
      ? () => schedule.openSchedule({ id: scheduleRow.id, objectType: 'automation' })
      : null
  if (block.status === 'invalid') {
    return (
      <ContextCard activity="error" title="Automation invalid">
        <Typography>{block.error}</Typography>
      </ContextCard>
    )
  }
  const active = activated || setup.status === 'active'
  const activate = (value) => setup.mutation.mutate({ days: value }, { onSuccess: () => setActivated(true) })
  return (
    <ContextCard
      activity={active ? 'success' : 'automation'}
      title={block.title}
      plain
      medium
    >
      <AutomationSetupContent {...{ active, setup, days, setDays, activate, title: block.title, onOpen }} />
    </ContextCard>
  )
}
